module.exports = __webpack_public_path__ + "static/media/spider-background.cd799872.svg";